import React from 'react'
import CardBox from '../../../../common/card/CardBox'
import GetContext from '../context/GetContext'

const UpperContent = ({ ...props }) => {
    
    const { groupReportSnapshot, selectedCourse, selectedUser } = GetContext( props.context )

    const courseReportBoxes = () => {
        return (
            <>
                <CardBox props={{ 
                    count: groupReportSnapshot.user_count ?? 0,
                    label: 'users',
                    labelSingular: 'user'
                 }} key={'users'} />
                <CardBox props={{ 
                    count: groupReportSnapshot.course_count ?? 0,
                    label: 'courses',
                    labelSingular: 'course'
                 }} key={'courses'} />
            </>
        )
    }

    const enrolledUsersBoxes = () => {
        return (
            <>
                <CardBox props={{ 
                    count: selectedCourse.enrolled ?? 0,
                    label: 'enrolled'
                 }}/>
                <CardBox props={{ 
                    count: selectedCourse.completed ?? 0,
                    label: 'completed'
                 }}/>
                <CardBox props={{ 
                    count: selectedCourse.inProgress ?? 0,
                    label: 'in progress'
                 }}/>
                <CardBox props={{ 
                    count: selectedCourse.notStarted ?? 0,
                    label: 'not started'
                 }}/>
            </>
        )
    }

    const enrolledCoursesBoxes = () => {
        return (
            <>
                <CardBox props={{ 
                    count: selectedUser.enrolledCount ?? 0,
                    label: 'enrolled'
                 }}/>
                <CardBox props={{ 
                    count: selectedUser.completedCount ?? 0,
                    label: 'completed'
                 }}/>
                <CardBox props={{ 
                    count: selectedUser.inProgressCount ?? 0,
                    label: 'in progress'
                 }}/>
                <CardBox props={{ 
                    count: selectedUser.notStartedCount ?? 0,
                    label: 'not started'
                 }}/>
            </>
        )
    }

    const getContent = () => {
        switch( props.from ){
            case 'Course Report':
                return {
                    title: groupReportSnapshot.team ?? '',
                    boxes: courseReportBoxes()
                }
            case 'Enrolled Users':
                return {
                    title: selectedCourse.course ?? '',
                    boxes: enrolledUsersBoxes()
                }
            case 'Lessons Report':
            case 'Topics Report':
            case 'Assignments Report':
                return {  
                    title: selectedUser.name ?? '',
                    boxes: ''
                }
            case 'User Report':
                return {
                    title: groupReportSnapshot.team ?? '',
                    boxes: courseReportBoxes()
                }
            case 'Enrolled Courses':
                return {
                    title: selectedUser.name ?? '',
                    boxes: enrolledCoursesBoxes()
                }
        }
    }
  
    return (
        <div className="msync-exported-pdf-upper-content" key={props.from}>
          <div className='msync-exported-pdf-upper-content__teams'>
            <span className='msync-exported-pdf-upper-content__teams_team'>{getContent().title}</span>
            <div className="msync-exported-pdf-upper-content__teams__filters">
              { ( props.from === 'Lessons Report' || props.from === 'Topics Report' || props.from === 'Assignments Report') && 
                <> <span><strong>Filters</strong></span>
                    <span>
                        <strong>Course: </strong>{ selectedCourse.course }
                    </span> </>
                }
              {/* <span><strong>Course Status:</strong> none</span>
              <span><strong>Users:</strong>none</span> */}
            </div>
          </div>
          <div className="msync-exported-pdf-upper-content__users_courses">
            <div className="msync-flex msync-flex--wrap">
             { getContent().boxes }
            </div>
          </div>
        </div>
    )
}

export default UpperContent